// 약관 관련 URL 상수
export const TERMS_URLS = {
  // 서비스이용약관
  SERVICE_TERMS:
    "https://aihomedoctor.notion.site/27e485675c2980a08410f80fca20eee0",

  // 개인정보처리방침
  PRIVACY_POLICY:
    "https://aihomedoctor.notion.site/27e485675c2980bbad97f85b13aa2c47",

  // 마케팅 목적 개인정보 수집 및 이용 동의
  MARKETING_CONSENT:
    "https://aihomedoctor.notion.site/27e485675c2980909006c559a1edd709",

  // 마케팅 정보 수신 동의
  MARKETING_INFO_RECEPTION:
    "https://aihomedoctor.notion.site/2c2485675c2980d39d8de2a72bb2702e",

  // AI홈닥터 개인정보 수집 및 이용 동의
  AI_HOMEDOCTOR_PERSONAL_INFO_CONSENT:
    "https://aihomedoctor.notion.site/27e485675c298012917df578347b0789",
} as const;
